const MILLISECONDS_PER_DAY = 86400 * 1000;

const FREQUENCY_RULES = {
  1: ["FREQ=DAILY"],
  2: ["FREQ=WEEKLY", "BYDAY=MO,TU,WE,TH,FR"],
  3: ["FREQ=WEEKLY"],
  4: ["FREQ=MONTHLY"],
  5: ["FREQ=YEARLY"],
};

function toFrequencyCode(recurringFrequency) {
  if (
    typeof recurringFrequency === "object"
      && recurringFrequency !== null
      && "value" in recurringFrequency
  ) {
    return Number(recurringFrequency.value);
  }

  return Number(recurringFrequency);
}

function pad(value, width) {
  return String(value).padStart(width, "0");
}

function toUtcStamp(date) {
  return `${date.getUTCFullYear()}${pad(date.getUTCMonth() + 1, 2)}${pad(date.getUTCDate(), 2)}`
    + `T${pad(date.getUTCHours(), 2)}${pad(date.getUTCMinutes(), 2)}${pad(date.getUTCSeconds(), 2)}Z`;
}

function formatUntilUtc(recurringEndTimestamp) {
  const timestamp = Number(recurringEndTimestamp);
  if (!timestamp) {
    return null;
  }

  const chosenDay = new Date(timestamp * 1000);
  const endOfChosenDay = new Date(chosenDay);
  endOfChosenDay.setHours(23, 59, 59, 0);

  if (endOfChosenDay.getTime() < chosenDay.getTime()) {
    endOfChosenDay.setTime(chosenDay.getTime() + MILLISECONDS_PER_DAY - 1000);
  }

  return toUtcStamp(endOfChosenDay);
}

function buildRRuleFromFrequency(options) {
  const { isRecurring, recurringFrequency, recurringEndTimestamp } = options;

  if (!isRecurring) {
    return "";
  }

  const ruleParts = FREQUENCY_RULES[toFrequencyCode(recurringFrequency)];
  if (!ruleParts) {
    return "";
  }

  const until = formatUntilUtc(recurringEndTimestamp);

  return (until ? [...ruleParts, `UNTIL=${until}`] : [...ruleParts]).join(";");
}

function isLegacyEditorEvent(event) {
  return Boolean(event) && typeof event.recurringFrequency === "object" && event.recurringFrequency !== null;
}

function legacyEditorRecurrenceFields(event) {
  const rrule = buildRRuleFromFrequency({
    isRecurring: event.isRecurring,
    recurringFrequency: event.recurringFrequency,
    recurringEndTimestamp: event.recurringEndTimestamp,
  });

  return {
    rrule,
    recurringStartTimestamp: rrule ? Number(event.recurringStartTimestamp) || 0 : 0,
    recurringEndTimestamp: rrule ? Number(event.recurringEndTimestamp) || 0 : 0,
  };
}

module.exports = {
  buildRRuleFromFrequency,
  isLegacyEditorEvent,
  legacyEditorRecurrenceFields,
  formatUntilUtc,
  toFrequencyCode,
};
